import { Button } from '@mui/material';
import BaseTable from 'components/ui/tables/BaseTable';
import useTopPanel from 'hooks/useTopPanel';
import React, { memo, useEffect, useState } from 'react';
import StaffAddEditModal from './AddEditModal';
import SimpleSearchInput from 'components/SearchInputNavbar';
import { useTranslation } from 'react-i18next';
import AccountMoneyFilterDrawer from '../../../components/dashboard/AccountMoneyFilterDrawer';

const Products = () => {
  const { setComponent } = useTopPanel();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setComponent(
      <div className='component-title'>Kassaga Qabul QIlingan Pullar</div>
    );
  }, [i18n.language]);

  const [refetch, setRefetch] = useState(false);
  const [openStaffModal, setOpenStaffModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [itemId, setItemId] = useState('');

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
              onClick={() => setOpenFilter(true)}
            >
              Filter
            </Button>
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 gap-2 flex items-center justify-center'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath='admin/accounts/incomes'
          emitTableColumns={{ open, setOpen }}
          tableName='expenses'
          headCells={[
            { code: 'account', label: 'Kassa' },
            { code: 'category', label: t('common.fields.category') },
            { code: 'partner', label: 'Hamkor' },
            { code: 'user', label: t('common.fields.staff') },
            { code: 'date', label: t('common.fields.date') },
            { code: 'sum', label: t('common.fields.sum') },
            { code: 'val', label: t('common.fields.val') },
          ]}
          columns={[
            { code: 'account', type: 'nested', childStr: 'name' },
            { code: 'category', type: 'nested', childStr: 'name' },
            { code: 'partner', type: 'nested', childStr: 'name' },
            { code: 'user', type: 'nested', childStr: 'name' },
            { code: 'date', type: 'date' },
            { code: 'sum', type: 'priceCurrency' },
            { code: 'val', type: 'price' },
          ]}
          actionModalEdit={{
            setOpen: setOpenStaffModal,
            setItemId: setItemId,
          }}
        />
      </div>
      {openStaffModal && (
        <StaffAddEditModal
          open={openStaffModal}
          setOpen={setOpenStaffModal}
          itemId={itemId}
          setItemId={setItemId}
          setRefetch={setRefetch}
        />
      )}
      <AccountMoneyFilterDrawer open={openFilter} setOpen={setOpenFilter} />
    </div>
  );
};

export default memo(Products);
